<template>
  <div> 
<md-card class="searchPanel">
  <md-card-content v-if="searchRequest">

    <md-dialog :md-active.sync="isFilterModalShowing" >
      <div> 
        <md-dialog-title>Filter</md-dialog-title>
        <div class="custButtonFilterRight"> 
          <md-button class="custButtonFilter md-primary md-raised " @click="doSearch">Search</md-button> 
          <md-button class="custButtonFilter md-raised " @click="isFilterModalShowing = false" >Close</md-button>
         </div>
      </div>
     <md-dialog-content>

      <div class = "inputBoxDouble" >

        <div class = "inputBoxSpace" >
          <md-field>
              <label>Chassis#</label>
              <md-input v-model="searchRequest.chassisNo"/>
          </md-field>
        </div>

        <div class = "inputBoxSpace" >
           <md-field>
              <label>LoadKey</label>
              <md-input v-model="searchRequest.seqNo"/>
          </md-field>
        </div>


      </div>

      <div class = "inputBoxDouble" >

        <div class = "inputBoxSpace" >
          <md-field>
             <label>Booking #</label>
             <md-input v-model="searchRequest.bookingNo"/>
         </md-field>
       </div>
           
       <div class = "inputBoxSpace" >
        <md-field>
           <label>IBD #</label>
           <md-input v-model="searchRequest.ibd"/>
        </md-field>
       </div>
      </div>

      <div class = "inputBoxDouble" >
        <div class = "inputBoxSpaceWide" >
        <auto-complete-master-data-select
                                              group="STC_CARRIER"
                                              label="Carrier"
                                              :init-value="searchRequest.carrier"
                                              :on-item-changed="handleCarrierChanged"
                                              >
        </auto-complete-master-data-select>
        </div>
      </div>
      <div class = "inputBoxDouble" >
      <div class = "inputBoxSpace" >
        <md-field>
          <label>Yard</label>
          <md-input v-model="searchRequest.transloadingYard" disabled/>
        </md-field>
      </div>

      <div class = "inputBoxSpace" >
        <md-field>
          <label>Seal#</label>
          <md-input v-model="searchRequest.sealNumber"/>
        </md-field>
      </div>
      </div>



    </md-dialog-content>
  </md-dialog>
  


      <div class="md-layout md-gutter">

        <div v-if="active" class="md-layout-item md-size-20 md-small-size-30">
          <div class = "inputBox" >
            <auto-complete-master-data-select
                                              group="REC_WINDOW"
                                              label="Rev. Windows"
                                              :preparedOptions="loaded_recwin"
                                              :init-value="searchRequest.receivingWindows"
                                              :on-item-changed="handleWindowsChanged"
                                              >
          </auto-complete-master-data-select>
          </div>
        </div>

        <div v-if="active" class="md-layout-item md-size-20 md-small-size-30">
          <div class = "inputBox" >
            <md-field>
                <label>Container#</label>
                <md-input v-model="searchRequest.containerNo"/>
            </md-field>
          </div>
        </div>



        <div  v-if="active" class="md-layout-item md-size-20 md-small-size-30">
          <div class = "inputBox">
            <datepicker v-model="searchRequest.gwDate.startDate">
              <label>GW Scale Date</label>
            </datepicker>
          </div>
        </div>
  
        <div  v-if="active" class="md-layout-item md-size-20 md-small-size-30">
          <div class = "inputBox">
            <datepicker v-model="searchRequest.gwDate.endDate">
              <label>To</label>
            </datepicker>
          </div>
        </div>
  
        <div v-if="active" class="md-layout-item md-size-20 md-small-size-30">
          <div class = "inputBox" >
           <md-field>
              <label>Input WTicket</label>
              <md-input v-model="searchRequest.scanWt"/>
          </md-field>
          </div>      
        </div>

      <div v-if="active" class="md-layout-item md-size-20 md-small-size-30">
        <div class = "inputBox">
        <md-field>
          <label>IBS</label>
          <md-input v-model="searchRequest.ibs"/>
        </md-field>
        </div>
      </div>


      <div  v-if="active" class="md-layout-item md-size-20 md-small-size-30">
        <div class = "inputBox">
          <datepicker v-model="searchRequest.chzStartDate.startDate">
            <label>Out Gate Date</label>
          </datepicker>
        </div>
      </div>

      <div  v-if="active" class="md-layout-item md-size-20 md-small-size-30">
        <div class = "inputBox">
          <datepicker v-model="searchRequest.chzStartDate.endDate">
            <label>To</label>
          </datepicker>
        </div>
      </div>

      <div  v-if="active" class="md-layout-item md-size-20 md-small-size-30">
        <div class = "inputBox">
          <datepicker v-model="searchRequest.chzEndDate.startDate">
            <label>In Gate Date</label>
          </datepicker>
        </div>
      </div>

      <div  v-if="active" class="md-layout-item md-size-20 md-small-size-30">
        <div class = "inputBox">
          <datepicker v-model="searchRequest.chzEndDate.endDate">
            <label>To</label>
          </datepicker>
        </div>
      </div>

      <div v-if="active" class="md-layout-item md-size-20 md-small-size-30">
     <div class = "inputBox">
        <auto-complete-master-data-select
                                      :prepared-options="this.getMasterDataAsSelectOptionByGroup('GST_LOAD_STATUS')"
                                      label="Status"
                                      :init-value="searchRequest.loadStatus"
                                      :on-item-changed="handleStatusChanged"
                                      >
        </auto-complete-master-data-select>
      </div>
      </div>

     </div>   
   </md-card-content>   

   <md-card-actions md-alignment="space-between">
    <!--<div v-if="getPermission.ibslist.edit" class="md-layout-item md-size-100 md-small-size-100">-->
      <div v-if="getPermission.ibslistob.view" class="md-layout-item md-size-100 md-small-size-100">   
          <callingApiCenter path="/api/w/fsi/GetIBSOutbound" :not-display-error="true">   

            <md-button class="md-raised custMenuButton" @click="filterBar"> Filter </md-button>
            <md-button class="custMenuButton md-raised" @click="doDownloadExcel" :disabled="!getDownloadCond"> Download </md-button>
            <input
                  class = "custSearchBar"
                  type="text"
                  placeholder="Searching Term"
                  v-model="searchtermFilter"
            />

            <div class="custButtonRight">
             <md-button class="md-raised custMenuButton md-primary" @click="doSearch">Search</md-button>
             <md-button class="md-raised custMenuButton" @click="doClear">Clear</md-button>
             <md-button class="md-icon-button" @click="mouseLeave" id="expand-button">
               <md-icon v-if="active == false">keyboard_arrow_down</md-icon>
               <md-icon v-if="active == true">keyboard_arrow_up</md-icon>
              </md-button>
            </div>

          </callingApiCenter>
      </div>
  </md-card-actions>
    

 
</md-card>

<pagination :items="getibsToDisplay">
  <template slot-scope="{pageItems}">
    <md-card class="data-table-container">
      <div class="outer-container">
        <div class="inner-container">
          <div class="table-header">
            <table id="headertable">
              <thead>
                <th ></th>
                <th
                class="header-cell center w3"
                v-on:click="sortFunction('loadStatus')">
                Status
              </th>

              <th
                class="header-cell center w3"
                v-on:click="sortFunction('receivingWindows')">
                Rev Window
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('containerNo')">
                Container#
              </th>
              <th
                class="header-cell center w6"
                v-on:click="sortFunction('chassisNo')">
                Chassis#
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('ctnrType')">
                CTN type
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('yard')">
                Yard Loc
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('stcSMSSend')">
                SMS Send
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('stcSMSDriver')">
                Send Driver
              </th>
              <th
                 class="header-cell center w4"
                 v-on:click="sortFunction('chzStartDate')">
                Out Gate Date
              </th>
              <th
                 class="header-cell center w4"
                 v-on:click="sortFunction('chzEndDate')">
                In Gate Date
              </th>
              <th
                class="header-cell center w3"
                v-on:click="sortFunction('scaleTicket')">
                Weight Ticket
              </th>

              <th
                class="header-cell center w5"
                v-on:click="sortFunction('scanWt')">
                Input WTicket
              </th>    
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('scanWt')">
                WTicket to SAP
              </th>    

              <th
                class="header-cell center w4"
                v-on:click="sortFunction('twDate')">
                Scale Date (T)
              </th>
              <th
                class="header-cell center w4"
                v-on:click="sortFunction('twDate')">
                Scale Time (T)
              </th>
              <th
                class="header-cell center w4"
                v-on:click="sortFunction('twDate')">
                Scale Time Web (T)
              </th>
              <th
                class="header-cell center w4"
                v-on:click="sortFunction('twYgNo')">
                Yard Goat (T)
              </th>
              <th
                class="header-cell center w4"
                v-on:click="sortFunction('twYgWeight')">
                Tare Weight
              </th>
              <th
                class="header-cell center w4"
                v-on:click="sortFunction('grade')">
                Grade
              </th>
              <th
                class="header-cell center w3"
                v-on:click="sortFunction('bales')">
                Bale
              </th>
              <th
                class="header-cell center w7"
                v-on:click="sortFunction('newSeal')">
                Seal No
              </th>
              <th
                class="header-cell center w4"
                v-on:click="sortFunction('gwDate')">
                Scale Date (G)
              </th>
              <th
                class="header-cell center w4"
                v-on:click="sortFunction('gwDate')">
                Scale Time (G)
              </th>

              <th
                class="header-cell center w4"
                v-on:click="sortFunction('gwDate')">
                Scale Time Web (G)
              </th>

              <th
                class="header-cell center w4"
                v-on:click="sortFunction('gwYgNo')">
                Yard Goat (G)
              </th>
              <th
                class="header-cell center w3"
                v-on:click="sortFunction('gwYgWeight')">
                Gross Weight
              </th>  
              <th
                class="header-cell center w3"
                v-on:click="sortFunction('weight')">
                Net Weight
              </th>

              <th
                class="header-cell center w7"
                v-on:click="sortFunction('bookingNo')">
                Booking
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('carrier2')">
                BK Carrier
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('ibd')">
                Custmoer order(IBD)
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('deliveryOrder')">
                Delivery Order
              </th>

              <th
                class="header-cell center w5"
                v-on:click="sortFunction('ibs')">
                Internal#
              </th>
              <th
                class="header-cell center w4"
                v-on:click="sortFunction('assignDate')">
                Assign Date
              </th>
              <th
                class="header-cell center w4"
                v-on:click="sortFunction('assignDate')">
                Assign Time
              </th>
              <th
                class="header-cell center w4"
                v-on:click="sortFunction('outboundDate')">
                Outbound Date
              </th>
              <th
                class="header-cell center w4"
                v-on:click="sortFunction('outboundDate')">
                Outbound Time
              </th>
              <th
                class="header-cell center w3"
                v-on:click="sortFunction('sapStatus')">
                SAP Status
              </th>
              <th
                class="header-cell center w3"
                v-on:click="sortFunction('carrier')">
                Carrier
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('transloadingYard')">
                Transloading Yard
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('seqNo')">
                Load Key
              </th>

  
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('unloadInfo')">
                
                Load Start Date
              </th>

              <th
                class="header-cell center w5"
                v-on:click="sortFunction('unloadInfo')">
                
                Load Start Time
              </th>

              <th
                class="header-cell center w5"
                v-on:click="sortFunction('unloadInfo')">
                
                Load End Date
              </th>

              <th
                class="header-cell center w5"
                v-on:click="sortFunction('unloadInfo')">
                
                Load End Time
              </th>

              <th
                class="header-cell center w5"
                v-on:click="sortFunction('unloadInfo')">
                
                Load User
              </th>

              </thead>
            </table>
          </div>
          <div class="table-body " @scroll="handleScroll">
            <table id="bodytable">
              <tbody>
                <tr v-for="item in pageItems">
                  <td></td>
                  <td class="body-cell excelBox w3" >
                    {{ item.loadStatus }}
                  </td>
                  <td class="body-cell excelBox w3">
                    {{ item.receivingWindows }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.containerNo }}
                  </td>
                  <td class="body-cell excelBox w6">
                    {{ item.chassisNo }}
                  </td>
                  <td class="body-cell excelBox w5">
                    <master-data-display group="GST_CTNRTYPE" :tag-id="item.ctnrType"/>
                  </td>
                  <td class="body-cell excelBox w5">
                    <div class = "spaceLine">{{item.yard}} - {{item.locationNumber}}</div>
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.stcSMSSend }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.stcSMSDriver }}
                  </td>
                  <td class="body-cell excelBox w4">
                    {{ item.chzStartDate | date }}
                  </td>
                  <td class="body-cell excelBox w4">
                    {{ item.chzEndDate | date }}
                  </td>
                  <td class="body-cell excelBox w3">
                    {{ item.scaleTicket }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.scanWt }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.scanWt == null ? item.scaleTicket : item.scanWt}}
                  </td>

                  <td class="body-cell excelBox w4">
                    {{ item.twDate | date }}
                  </td>
                  <td class="body-cell excelBox w4">
                    {{ item.twDate | time }}
                  </td>
                  <td class="body-cell excelBox w4">
                    {{ item.twDateWeb | time }}
                  </td>
                  <td class="body-cell excelBox w4">
                    {{ item.twYgNo }}
                  </td>
                  <td class="body-cell excelBox w4">
                    {{ item.tareWeight }}
                  </td>
                  <td class="body-cell excelBox w4">
                    {{ item.grade }}
                  </td>
                  <td class="body-cell excelBox w3">
                    {{ item.bales }}
                  </td>
                  <td class="body-cell excelBox w7">
                    {{ item.newSeal }}
                  </td>
                  <td class="body-cell excelBox w4">
                    {{ item.gwDate | date}}
                  </td>
                  <td class="body-cell excelBox w4">
                    {{ item.gwDate | time }}
                  </td>
                  <td class="body-cell excelBox w4">
                    {{ item.gwDateWeb | time }}
                  </td>
                  <td class="body-cell excelBox w4">
                    {{ item.gwYgNo }}
                  </td>
                  <td class="body-cell excelBox w3">
                    {{ item.vgmWeight }}
                  </td>
                  <td class="body-cell excelBox w3">
                    {{ item.weight }}
                  </td>

                  <td class="body-cell excelBox w7">
                    {{ item.bookingNo }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.carrier2 }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.ibd }}
                  </td>

                  <td class="body-cell excelBox w5">
                    {{ item.deliveryOrder }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.ibs }}
                  </td>
                  <td class="body-cell excelBox w4">
                    {{ item.assignDate | date }}
                  </td>
                  <td class="body-cell excelBox w4">
                    {{ item.assignDate | time}}
                  </td>
                  <td class="body-cell excelBox w4">
                    {{ item.outboundDate | date }}
                  </td>
                  <td class="body-cell excelBox w4">
                    {{ item.outboundDate | time}}
                  </td>
                  <td class="body-cell excelBox w3">
                    {{ item.sapStatus}}
                  </td>
                  <td class="body-cell excelBox w3">
                    {{ item.carrier }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.transloadingYard }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.seqNo }}
                  </td>
                  
                  <td class="body-cell excelBox w5">
                    {{ item.unloadStartTimeStamp | date }}
                  </td>

                  <td class="body-cell excelBox w5">
                    {{ item.unloadStartTimeStamp | time }}
                  </td>

                  <td class="body-cell excelBox w5">
                    {{ item.unloadEndTimeStamp | date}}
                  </td>

                  <td class="body-cell excelBox w5">
                    {{ item.unloadEndTimeStamp | time}}
                  </td>

                  <td class="body-cell excelBox w5">
                    {{ item.uploadMobileUser }}
                  </td>


              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </md-card>
  </template>
</pagination>
</div>
</template>


<style scoped>
@import '../../public/chris.css';

.excelBox {
padding-top: 15px;
padding-bottom: 15px;
padding-left: 5px;
padding-right: 5px;
text-align: center;

}

.material-icons.md-18 { font-size: 18px; }
.material-icons.md-24 { font-size: 24px; }
.material-icons.md-36 { font-size: 36px; }
.material-icons.md-48 { font-size: 100px; }
.material-icons.md-light { color: rgba(255, 255, 255, 1); }
.material-icons.md-light.md-inactive { color: rgba(255, 255, 255, 0.3); }

.icons-center {
vertical-align: middle;
margin-right: 10px;
}

.inputBox {
border: 1px solid #cacbcc;
border-radius: 5px;
color: #29303b;
font-size: 18px;
height: auto;
line-height: 1.5em;
padding: 5px 5px 5px 5px;
margin-top: 5px;
}

.inputBox:hover {

border: 2px solid #448aff;
border-radius: 5px;
color: #29303b;
font-size: 18px;
height: auto;
line-height: 1.5em;
padding: 6px 6px 6px 6px;
margin-top: 5px;
background-color: #e0eff7;
  
}

/* .selected {
 background: #726a95;
} */

.tableW {
height: 40px;
}

.center {
text-align: center;
}

tr:hover {
background: #c8e6f5;
}

.headerCenter {
text-align: center;
}


.modal {
 background-color: #29303b;
  border-radius: 5px;
}
.modalTitle {
font-weight: normal;
font-family: 'UberMove', 'Open Sans', 'Helvetica Neue', Helvetica, sans-serif !important;
font-weight: 500;
color: white;
font-family: Poppins, sans-serif;
margin-bottom: 0.5rem;
line-height: 1.6;
}

.md-menu {
padding: 0;
padding: 0;

}

.custButton {
margin: 10px;
width: 120px;
height: 40px;
line-height:40px;
font-size: 0.8rem;

}

.custMenuButton {

width: 110px;
height: 40px;
line-height:45px;
font-size: 0.9rem;
align-self: center;

}

.custButtonRight {
  margin: 3px;
  width: 300px;
  height: 40px;
  float: right;
}

.custButtonFilter{
  margin: 5px;
  width: 80px ;
  height: 30px ;
  font-size: 0.7rem ;
}

.custButtonFilterRight {
  margin: 5px;
  width: 200PX;
  height: 40px;
  float: right;
}
.inputBoxSpace {
    border: 1px solid #cacbcc;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    width: 200px;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px;
  }

.inputBoxDouble {
    width: 400px;
    justify-content: space-around;
    display: flex;
  flex-direction: row;
  }

.inputBoxSpaceWide {
    border: 1px solid #cacbcc;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    width: 400px;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px;
  }
  .result-included-outter-div {
    border: 1px solid #D0D0D0;
    border-radius: 5px;
    width: auto;
    padding: 10px;
    height: auto;
    margin-top: 5px;
    margin-bottom: 5px;
    margin-left: 20px;
}
.result-included-inner-div {
    margin-left: 5px;
    font-weight: bold;
    margin-bottom: -25px;
}
.result-included-div-span {
    margin-left: 100px; 
    margin-top: -10px;
}
.result-included-span {
    margin-left: 5px;
}
</style>

<script>
/* eslint-disable no-plusplus */
import { mapGetters } from 'vuex';
import dateFormat from '../utils/dateFormat';
//import api from "../api";
import { newAPIPost } from '../api';
import parseXls from "../utils/parseXls";
import callingApiCenter from "../components/CallingApiCenter.vue";
import sort from "fast-sort";
import toGenerateExcelRequest, { downloadExcel } from "../utils/excel";


const getInitSearch = () => ({

  salesOffice: null,
  transloadingYard: '1010001',
  receivingWindows: null,
  loadStatus: null,
  seqNo: null,
  scaleTicket: null,
  scanWt: null,
  containerNo: null,
  chassisNo: null,
  bookingNo: null,
  ibd: null,
  gwDate: {
      startDate: null,
      endDate: null,
    },
  carrier: null,
  sealNumber: null,
  chzEndDate: {
      startDate: null,
      endDate: null,
  },
  chzStartDate: {
      startDate: null,
      endDate: null,
  },
  outboundDate: {
      startDate: null,
      endDate: null,
    },
});

export default {

data: () => ({
  searchRequest: getInitSearch(),
  active: true,
  isFilterModalShowing:false,
  ibsoutbound: [],
  items:[],
  searchtermFilter: "",
  trimOption: [
      "scaleTicket",
      "scanWt",
      "containerNo",
      "chassisNo",
      "bookingNo",
      "ibd",
      "sealNumber",
      "ibs"
    ],
  loaded_recwin: [],
  loaded_recwin_id: [],  
}),


components: {
  callingApiCenter,
},

watch: {
  getibsOutbound(val) {
    this.updateibsOutbound(val);
  },
},

computed: {
...mapGetters([
    'getPermission',
    'getUserProfile',
    'getRole',
    'getibsOutbound',
    'getMasterDataName',
    'getMasterDataByGroup',
    'getMasterDataAsSelectOptionByGroup',
  ]),

  getibsToDisplay() {
    return this.ibsoutbound.filter(it => this.loaded_recwin_id.includes(it.receivingWindows)).filter((row) => {
        const term = this.searchtermFilter.toUpperCase().trim();
        return (
          this.includeNull(row.seqNo).includes(term) ||
          this.includeNull(row.containerNo).includes(term) ||
          this.includeNull(row.chassisNo).includes(term) ||
          this.includeNull(row.scaleTicket).includes(term) ||
          this.includeNull(row.scanWt).includes(term) ||
          this.includeNull(row.deliveryOrder).includes(term) ||
          this.includeNull(row.bookingNo).includes(term) ||
          this.includeNull(row.ibs).includes(term)
        );
      });

      // return this.ibsoutbound;
    },  


  getOutboundStatus() {
     return [
        {
          id: 'EPT',
          name: 'EMPTY',
        },
        {
          id: 'LD',
          name: 'LOADED',
        },
        {
          id: 'ASN',
          name: 'Assigned',
        },
        {
          id: 'OU',
          name: 'Outbound',
        },
     ]
  },

  getDownloadCond() {
       return this.ibsoutbound.length > 0;
    },

},    
async mounted() {
    const cachedSearchRequest = this.searchRequest;
    if (cachedSearchRequest && !_(cachedSearchRequest).isEmpty()) {
    this.searchRequest = JSON.parse(JSON.stringify(cachedSearchRequest));
  } else {
   this.searchRequest = getInitSearch(this);
  }
  console.log("this.ibsoutbound:" + this.searchRequest);

  var p_loaded_recwin = this.getMasterDataByGroup('REC_WINDOW');
  if (p_loaded_recwin.length > 0)
  {
    if (!this.getPermission.stc.view)
    {
        this.loaded_recwin = p_loaded_recwin.filter( it => it.tagName != 'STC');
    } else {
        this.loaded_recwin = p_loaded_recwin;
    }
    this.loaded_recwin.forEach((it) => {
      this.loaded_recwin_id.push(it.tagId); 
    });
    console.log(`inbound rec win1 : ${JSON.stringify(this.loaded_recwin)}`);

  } else {
    //this.inbound_recwin = api.post('/api/w/masterData', {groups: ['REC_WINDOW']}).filter( it => it.tagName != 'STC');
    //api.post('/api/w/masterData', {groups: ['REC_WINDOW']})
    newAPIPost('/api/w/masterData', {groups: ['REC_WINDOW']})
      .then((res) => {
          p_loaded_recwin = res.filter(it => it.tagName != 'STC' && it.active);
          p_loaded_recwin.forEach((it) => {
            it.id = it.tagId;
            it.name = it.tagName;
            if (this.getPermission.stc.view)
            {
              this.loaded_recwin.push(it);
              this.loaded_recwin_id.push(it.tagId)
            }
          })
          console.log(`inbound rec win: ${JSON.stringify(this.inbound_recwin)}`);
    });
  }

},

 methods: {

   trimTool(ent) {
      return ent == null ? null : ent.trim()
    },

  handleStatusChanged(id) {
      this.searchRequest.loadStatus = id;
      if (id != 'OU')
      {
        this.searchRequest.gwDate.startDate = null;
        this.searchRequest.gwDate.endDate = null;
      }
    },

    handleCarrierChanged(id) {
      this.searchRequest.carrier = id;
    },

    handleWindowsChanged(id) {
        this.searchRequest.receivingWindows = id;
    },

    getDisplay(group, tagId) {
      if (!tagId) {
        return "";
      }
      return this.getMasterDataName(group, tagId) || this.tagId;
    },

    mouseOver: function(){
        this.active = true;
    },

    mouseLeave: function() {
      this.active = !this.active;
    },

    updateibsOutbound(ibsoutbound) {
      var items = JSON.parse(JSON.stringify(ibsoutbound));
      this.ibsoutbound = items;
    },

    doSearch() {
    this.active = false;
    console.log("this.ibsoutbound:" + this.searchRequest);
    for (const el of this.trimOption) {
        this.searchRequest[el] = this.trimTool(this.searchRequest[el]);
      }
    this.$nextTick(() => {
      this.$store.dispatch('ibsOutboundsList', this.searchRequest);
    })
    },

    doClear() {
    this.$nextTick(() => {
      this.searchRequest = getInitSearch();
    });
    },

    filterBar(){
      this.isFilterModalShowing = true;
    },

    handleScroll(e) {
       $(this.$el.querySelector('.table-header'))
       .offset({
          left: -1 * (e.target.scrollLeft - $('.outer-container')
           .offset().left),
      });
    },

    includeNull(field) {
      return field == null ? "" : field;
    },

    sortFunction(sortFiled){
      const sorted = sort(this.ibsoutbound).asc(sortFiled);
      this.sortStatus = !this.sortStatus;
      console.log(this.sortStatus)
      console.log(this.ibsoutbound)
    if (this.sortStatus)
      {
        this.items = sorted;
      }
    else
      {
      this.items = sorted.reverse();
    }
            
   },

   doDownloadExcel(){
       const request = toGenerateExcelRequest(
          this.$el.querySelector('.data-table-container .inner-container'),
          'IBSOutboundList.xls',
          1,
        );
        request.heads = _(request.heads).take(request.heads.length);
        request.rows = _(this.getibsToDisplay)
        .map(item => [
        item.loadStatus,
            item.receivingWindows,
            item.containerNo,
            item.chassisNo,
            this.getDisplay('GST_CTNRTYPE', item.ctnrType),
            `${item.yard} - ${item.locationNumber}` ,
            item.stcSMSSend,
            item.stcSMSDriver,
            dateFormat.date(item.chzStartDate),
            dateFormat.date(item.chzEndDate),
            item.scaleTicket,
            item.scanWt,
            item.scanWt == null ? item.scaleTicket : item.scanWt,
            dateFormat.date(item.twDate),
            dateFormat.time(item.twDate),
            dateFormat.time(item.twDateWeb),
            item.twYgNo,
            item.tareWeight,
            item.grade, 
            item.bales, 
            item.newSeal,
            dateFormat.date(item.gwDate),
            dateFormat.time(item.gwDate),
            dateFormat.time(item.gwDateWeb),
            item.gwYgNo,
            item.vgmWeight,
            item.weight,
            item.bookingNo,
            item.carrier2,
            item.ibd,
            item.deliveryOrder,
            item.ibs,
            dateFormat.date(item.assignDate),
            dateFormat.time(item.assignDate), 
            dateFormat.date(item.outboundDate),
            dateFormat.time(item.outboundDate),
            item.sapStatus, 
            item.carrier, 
            item.transloadingYard,     
            item.seqNo,
            dateFormat.date(item.unloadStartTimeStamp),
            dateFormat.time(item.unloadStartTimeStamp),
            dateFormat.date(item.unloadEndTimeStamp),
            dateFormat.time(item.unloadEndTimeStamp),
            item.uploadMobileUser,

          ]);
        this.$store.dispatch('generateExcel', request)
          .then((res) => {
            window.open(res.url, 'blank');
      });
    },



 }
}
</script>